import React, { Component } from 'react';
import TournamentOverlay, { Aviso } from './TournamentOverlay';

// Armar una ronda a mano, o mover jugadores entre mesas de una ronda abierta antes de cargarla.
// El ORDEN dentro de cada mesa es el orden de juego (1º, 2º…): las bases de Catan eligen el color
// por orden de juego, así que acá se ve y se ajusta con ↑ ↓.
//
// Sin arrastrar: en la tablet del mostrador un select "a la mesa N" es más confiable que un drag.
//
// props:
//   modo: 'manual' (la próxima ronda, se pueden agregar o quitar mesas) | 'reseat' (mesas fijas)
//   mesas: [{ tableId?, number?, jugadores: [{ id, name }] }]
//   onSave(mesas) → promesa
class SeatingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mesas: props.mesas.map((m) => ({ ...m, jugadores: m.jugadores.slice() })),
            saving: false,
            error: null,
        };
    }

    actualizar = (fn) => {
        const mesas = this.state.mesas.map((m) => ({ ...m, jugadores: m.jugadores.slice() }));
        fn(mesas);
        this.setState({ mesas, error: null });
    }

    mover = (mi, ji, d) => this.actualizar((mesas) => {
        const lista = mesas[mi].jugadores;
        const k = ji + d;
        if (k < 0 || k >= lista.length) return;
        [lista[ji], lista[k]] = [lista[k], lista[ji]];
    })

    aMesa = (mi, ji, destino) => this.actualizar((mesas) => {
        const [j] = mesas[mi].jugadores.splice(ji, 1);
        mesas[destino].jugadores.push(j);
    })

    agregarMesa = () => this.actualizar((mesas) => { mesas.push({ jugadores: [] }); })

    quitarMesasVacias = () => this.actualizar((mesas) => {
        for (let i = mesas.length - 1; i >= 0; i--) if (!mesas[i].jugadores.length) mesas.splice(i, 1);
    })

    guardar = async () => {
        const { mesas } = this.state;
        const chicas = mesas.filter((m) => m.jugadores.length < 2);
        if (chicas.length && (this.props.modo === 'reseat' || chicas.some((m) => m.jugadores.length === 1))) {
            this.setState({ error: 'Cada mesa tiene que tener al menos 2 jugadores. Quitá las mesas vacías o completalas.' });
            return;
        }
        this.setState({ saving: true, error: null });
        try {
            await this.props.onSave(mesas.filter((m) => m.jugadores.length));
        } catch (e) {
            this.setState({ saving: false, error: e.message });
        }
    }

    render() {
        const { mesas } = this.state;
        const manual = this.props.modo === 'manual';
        return (
            <TournamentOverlay width={940} onClose={this.props.onClose}
                title={manual ? `Armar la ronda ${this.props.numero || ''} a mano` : 'Mover jugadores y orden de juego'}
                footer={(
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
                        <button type="button" className="btn btn-accent" disabled={this.state.saving} onClick={this.guardar}>
                            {this.state.saving ? 'Guardando…' : manual ? 'Armar la ronda así' : 'Guardar mesas'}
                        </button>
                        {manual ? (
                            <React.Fragment>
                                <button type="button" className="btn btn-white" onClick={this.agregarMesa}>+ Mesa</button>
                                <button type="button" className="btn btn-white" onClick={this.quitarMesasVacias}>Quitar mesas vacías</button>
                            </React.Fragment>
                        ) : null}
                    </div>
                )}>
                <Aviso tipo="info">
                    {manual
                        ? 'Arranca con un reparto sugerido. Mové a cada uno con "a la mesa…" y ordená con ↑ ↓: el de arriba juega primero. Tienen que quedar sentados todos los presentes.'
                        : 'Sólo se pueden tocar las mesas que todavía no se cargaron. El de arriba juega primero.'}
                </Aviso>
                {this.state.error ? <Aviso tipo="error">{this.state.error}</Aviso> : null}
                <div className="row">
                    {mesas.map((m, mi) => (
                        <div className="col-lg-3 col-md-4 col-sm-6" key={mi}>
                            <div style={{ border: '1px solid #E1E5EB', borderRadius: '.25rem', padding: 8, marginBottom: 12 }}>
                                <div className="d-flex justify-content-between" style={{ fontSize: 12.5, marginBottom: 6 }}>
                                    <strong>Mesa {m.number || mi + 1}</strong>
                                    <span className={m.jugadores.length < 2 ? 'text-danger' : 'text-muted'}>{m.jugadores.length} jug.</span>
                                </div>
                                {m.jugadores.map((j, ji) => (
                                    <div key={j.id} className="d-flex align-items-center" style={{ gap: 4, fontSize: 12.5, marginBottom: 4 }}>
                                        <span style={{ width: 20, color: '#818EA3' }}>{ji + 1}º</span>
                                        <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{j.name}</span>
                                        <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={ji === 0}
                                            onClick={() => this.mover(mi, ji, -1)} aria-label="Subir">↑</button>
                                        <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={ji === m.jugadores.length - 1}
                                            onClick={() => this.mover(mi, ji, 1)} aria-label="Bajar">↓</button>
                                        {mesas.length > 1 ? (
                                            <select className="form-control form-control-sm" style={{ width: 62, padding: '0 2px', height: 24 }}
                                                value="" onChange={(e) => e.target.value !== '' && this.aMesa(mi, ji, Number(e.target.value))}
                                                aria-label={`Mover a ${j.name} a otra mesa`}>
                                                <option value="">→</option>
                                                {mesas.map((x, k) => (k === mi ? null : <option key={k} value={k}>M{x.number || k + 1}</option>))}
                                            </select>
                                        ) : null}
                                    </div>
                                ))}
                                {m.jugadores.length ? null : <div className="text-muted" style={{ fontSize: 12 }}>Vacía</div>}
                            </div>
                        </div>
                    ))}
                </div>
            </TournamentOverlay>
        );
    }
}

export default SeatingModal;
